import React from 'react';
import CreateSalesOrderTab from './CreateSalesOrderTab';

function UpdateSalesOrder() {
  return (
    <div>
      <CreateSalesOrderTab />
    </div>
  )
}

UpdateSalesOrder.auth = {
    path: "/order/update_sales_order",
    role: "super-admin admin",
  };

export default UpdateSalesOrder